import React, { useEffect, useRef } from 'react';
import Icon from './Icon';
import { janela } from '../services/plataforma';

// ─────────────────────────────────────────────────────────────────────────────
// "Sem atendimento em andamento".
//
// Este é o único aviso do Orion que INSISTE. Todos os outros são toasts que
// somem sozinhos; este fica na frente e apita até alguém clicar.
//
// O motivo é o que ele significa: o operador está dentro do expediente e sem
// nenhum ticket em atendimento há 25 minutos. Um toast que some em 5 segundos
// enquanto ele está de costas para a tela não cumpre função nenhuma.
//
// O bip é gerado pela Web Audio API — sem arquivo de som, sem carregar nada.
// 880 Hz é agudo o suficiente para se destacar do ruído de escritório sem ser
// estridente, e o volume é baixo de propósito: é um lembrete, não um alarme.
// ─────────────────────────────────────────────────────────────────────────────

const FREQUENCIA_HZ = 880;
const DURACAO_BIP_S = 0.24;
const INTERVALO_BIP_MS = 900;
const VOLUME = 0.06;

export default function AlertaOciosidade({ minutos, aoEntender }) {
  const audioRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    // A janela pode estar minimizada no botão flutuante ou atrás de outra
    // coisa: o aviso não serve se ninguém o vê.
    try { janela.restaurar(); } catch (e) { /* no navegador não há o que restaurar */ }

    const Contexto = window.AudioContext || window.webkitAudioContext;
    if (!Contexto) return undefined;

    let ctx;
    try {
      ctx = new Contexto();
      audioRef.current = ctx;
    } catch (e) {
      return undefined;   // sem áudio disponível, o modal sozinho já avisa
    }

    const bipar = () => {
      try {
        const osc = ctx.createOscillator();
        const ganho = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = FREQUENCIA_HZ;
        ganho.gain.value = VOLUME;
        osc.connect(ganho).connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + DURACAO_BIP_S);
      } catch (e) { /* o navegador pode bloquear áudio sem interação prévia */ }
    };

    bipar();
    timerRef.current = setInterval(bipar, INTERVALO_BIP_MS);

    return () => {
      clearInterval(timerRef.current);
      try { ctx.close(); } catch (e) { /* já fechado */ }
    };
  }, []);

  return (
    <div className="drawer-overlay drawer-overlay-alto">
      <div className="modal-nx modal-estreito" onClick={e => e.stopPropagation()}>
        <div className="drawer-head">
          <div className="drawer-title">
            Sem atendimento em andamento
            <span className="drawer-sub">há {minutos} minutos</span>
          </div>
        </div>

        <div className="drawer-body">
          <div className="panel panel-dest d-atual" style={{ marginBottom: 0 }}>
            <Icon name="clock" size={16} style={{ marginRight: 8 }} />
            Você está dentro do expediente e sem nenhum ticket em atendimento.
            Seu status foi para <b>Ociosidade</b>.
            <div className="campo-dica" style={{ marginTop: 10 }}>
              Assumir um ticket volta o status para Ativo sozinho. Se estiver em pausa,
              marque o motivo pela pílula no topo — assim o tempo fica registrado certo.
            </div>
          </div>
        </div>

        <div className="drawer-foot">
          <button className="btn btn-primary" onClick={aoEntender} autoFocus>
            <Icon name="check" size={14} /> Entendi
          </button>
        </div>
      </div>
    </div>
  );
}
